/**
 * camera = 웹 카메라 레이어 / native-scanner = 구버전 Android 앱의 네이티브 스캐너 /
 * pc-notice = 카메라 대신 안내만 / hidden = 버튼을 숨긴다
 */
export type QrEntryMode = 'camera' | 'native-scanner' | 'pc-notice' | 'hidden'

// 출시본 앱은 웹뷰 카메라 권한(onPermissionRequest)이 없어 getUserMedia 가 실패한다
export const getQrEntryMode = ({
  isAppAndroid,
  isAppIpad,
  appVersion,
  webCameraAppVersion,
  hasNativeScanner,
  isTabletOrPhone,
}: {
  isAppAndroid: boolean
  isAppIpad: boolean
  appVersion: number | undefined
  webCameraAppVersion: number
  hasNativeScanner: boolean
  isTabletOrPhone: boolean
}): QrEntryMode => {
  if (isAppAndroid) {
    if ((appVersion ?? 0) >= webCameraAppVersion) return 'camera'
    return hasNativeScanner ? 'native-scanner' : 'hidden'
  }
  // iPad 앱 웹뷰는 카메라 권한 처리가 확인되지 않았다
  if (isAppIpad) return 'hidden'
  return isTabletOrPhone ? 'camera' : 'pc-notice'
}
